import { FETCH_PROJECT_ALERTS, CLEAR_PROJECT_ALERTS } from '#action/types';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_PROJECT_ALERTS:
      const stringedData = action.payload.map(el => {
        const res = { ...el };
        if (res.tMin !== undefined) res.tMin += '';
        if (res.tMax !== undefined) res.tMax += '';
        if (res.hMin !== undefined) res.hMin += '';
        if (res.hMax !== undefined) res.hMax += '';
        if (res.startDelay && res.startDelay > 0) res.startDelay = Number(res.startDelay) / 60000;
        if (res.minAlertPeriod && res.minAlertPeriod > 0) {
          res.minAlertPeriod = Number(res.minAlertPeriod) / 60000;
        }
        return res;
      });
      return { ...state, [action.id]: stringedData };
    case CLEAR_PROJECT_ALERTS:
      return defaultState;
    default:
      return state;
  }
};
